export default {"src":"/_next/static/media/la-2.12a4b42f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};